// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"69389994","453":"16ecd17d"}[chunkId] + ".chunk.js";
};